import { Log } from "ng2-logger";
import { TranslateService } from "@ngx-translate/core";
import { Component, EventEmitter, HostListener, Input, OnInit, Output } from "@angular/core";

/**
 * TODO ... This is used just as a dummy status display. The correct thing to do it to extract tool scanning in this reusable component.
 */
@Component({
    selector: 'app-tool-scanner',
    templateUrl: './tool-scanner.component.html',
    styleUrls: ['./tool-scanner.component.scss']
})
export class ToolScannerComponent implements OnInit {
    _logger = Log.create(ToolScannerComponent.name);


    @Input() scanner = false;

    @Output() scan = new EventEmitter<any>();
    @Output() error = new EventEmitter<any>();

    focused = true;

    constructor(private translateService: TranslateService) {
    }

    ngOnInit(): void {
    }


    @HostListener('window:focus', ['$event'])
    onFocus() {
        this.focused = true;
    }

    @HostListener('window:blur', ['$event'])
    onBlur() {
        this.focused = false;
    }

    onScan(boschId: string) {
        this.scan.emit(boschId);
    }

    onError(boschId: string) {
        this.error.emit(boschId);
    }

    get scanAnimation() {
        return this.focused ? '../../../assets/images/tool_scan_enabled.gif' : '../../../assets/images/badge_scan_disabled.gif';
    }

    get scanMessage() {
        return this.focused ? this.translateService.instant('generic.scanner.focused') : this.translateService.instant('generic.scanner.notFocused')
    }

}
